<script setup lang="ts">
const columns = [{
  label: 'Über uns',
  children: [{
    label: 'Kontakt',
    to: '/kontakt'
  }, {
    label: 'Impressum',
    to: '/impressum'
  }, {
    label: 'FAQ',
    to: '/faq'
  }]
}, {
  label: 'Kurse',
  children: [{
    label: 'Kurse für Eltern',
    to: '/kurs/eltern'
  }, {
    label: 'Kurse für Senioren',
    to: '/kurs/senioren'
  }, {
    label: 'Smart Home Kurse',
    to: '/kurs/smart-home'
  }, {
    label: 'Web Development Kurse',
    to: '/kurs/web-dev'
  }]
}, {
  label: 'Lehrgänge',
  children: [{
    label: 'Web Foundation',
    to: '/lehrgang/foundation'
  }, {
    label: 'Web Developer',
    to: '/lehrgang/developer'
  }]
}]

const toast = useToast()

const email = ref('')
const loading = ref(false)

async function onSubmit() {
  loading.value = true
  try {
    const res = await fetch('/api/newsletter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: String(email.value) })
    })
    email.value = ''
    if (!res.ok) {
      const data = await res.json() as { statusMessage?: string }
      toast.add({
        title: 'Fehler',
        description: data.statusMessage || 'Anmeldung fehlgeschlagen. Bitte versuche es später erneut.',
        color: 'error'
      })
      return
    }
    toast.add({
      title: 'Angemeldet!',
      description: 'Du hast dich erfolgreich für unseren Newsletter angemeldet.',
      color: 'success'
    })
  } catch (e: unknown) {
    const msg = e instanceof Error ? e.message : undefined
    toast.add({
      title: 'Fehler',
      description: msg || 'Anmeldung fehlgeschlagen. Bitte versuche es später erneut.',
      color: 'error'
    })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <!-- Lighthouse Best-Practices: "image-aspect-ratio". USeparators Border-Linien
       haben `w-full` und schrumpfen per Flexbox-Default (flex-shrink: 1) auf die
       verfügbare Breite – ohne `shrink-0` auf dem Label-Container wird dieses
       Schrumpfen proportional auch auf ihn (und damit das Logo) angewendet und
       staucht es von ~56×56px auf 27×56px, unabhängig von den korrekten
       width/height-Attributen auf dem <img>. Siehe docs/offene-punkte-webpro-llm.md. -->
  <USeparator
    class="h-px"
    :ui="{ container: 'shrink-0' }"
  >
    <NuxtImg
      src="/webpro.svg"
      alt="Web Professionals"
      width="105"
      height="104"
      class="h-14 w-auto"
    />
  </USeparator>

  <UFooter :ui="{ top: 'border-b border-default' }">
    <template #top>
      <UContainer>
        <UFooterColumns :columns="columns">
          <template #right>
            <form @submit.prevent="onSubmit">
              <UFormField
                name="email"
                label="Für Newsletter anmelden:"
                size="lg"
              >
                <UInput
                  v-model="email"
                  type="email"
                  class="w-full"
                  placeholder="Bitte gib deine E-Mail Adresse ein"
                >
                  <template #trailing>
                    <UButton
                      type="submit"
                      size="xs"
                      color="neutral"
                      label="Anmelden"
                      :loading="loading"
                    />
                  </template>
                </UInput>
              </UFormField>
            </form>

            <div class="mt-4 flex items-center gap-3 rounded-lg border border-default bg-background p-3">
              <NuxtImg
                src="/whatsapp_qr.svg"
                alt="QR Code – WhatsApp Community Web Professionals"
                class="w-20 h-20 shrink-0"
              />
              <div>
                <div class="flex items-center gap-1.5 mb-1">
                  <UIcon
                    name="i-simple-icons-whatsapp"
                    class="text-[#25D366] text-base shrink-0"
                  />
                  <p class="text-sm font-semibold text-default">
                    WhatsApp Community
                  </p>
                </div>
                <UButton
                  to="https://chat.whatsapp.com/IuBcKFBjRnYJtqAMzP72T5"
                  target="_blank"
                  rel="noopener"
                  variant="link"
                  size="xs"
                  color="success"
                  label="Community beitreten →"
                  class="px-0"
                />
              </div>
            </div>
          </template>
        </UFooterColumns>
      </UContainer>
    </template>

    <template #left>
      <p class="text-muted text-sm">
        © Web Professionals GmbH {{ new Date().getFullYear() }}
      </p>
    </template>

    <template #right>
      <!--
      <UButton
        to="https://go.nuxt.com/discord"
        target="_blank"
        icon="i-simple-icons-discord"
        aria-label="Nuxt on Discord"
        color="neutral"
        variant="ghost"
      />
      <UButton
        to="https://go.nuxt.com/x"
        target="_blank"
        icon="i-simple-icons-x"
        aria-label="Nuxt on X"
        color="neutral"
        variant="ghost"
      />
      -->
      <UButton
        to="https://www.youtube.com/channel/UCqBw30GcrJDms54l1g4CAWQ"
        target="_blank"
        icon="i-simple-icons-youtube"
        aria-label="Web Professionals auf YouTube"
        color="neutral"
        variant="ghost"
      />
      <UButton
        to="https://chat.whatsapp.com/IuBcKFBjRnYJtqAMzP72T5"
        target="_blank"
        icon="i-simple-icons-whatsapp"
        aria-label="Web Professionals WhatsApp Community"
        color="neutral"
        variant="ghost"
      />
    </template>
  </UFooter>
</template>
